// extracted by mini-css-extract-plugin
export var lightMode = "_1i-0";